import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getSettings } from "@/services/api";
import { setRevealAfterClose } from "@/utils/format";

const SettingsContext = createContext(null);

const DEFAULTS = {
  business_name: "BGRMATKA",
  tagline: "Live Results & Analytics Portal",
  mobile: "8838576060",
  email: "info@bgrmatka.com",
  domain: "bgrmatka.com",
  refresh_interval: 5,
  lucky_ank: "3-7-8-9",
  final_ank: "K-1, M-9",
  whatsapp: "https://whatsapp.com/channel/0029Vb9Ql9bF6sn7malijf1H",
  telegram: "https://t.me/bgrmatka",
  reveal_after_close: false,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await getSettings();
      const merged = { ...DEFAULTS, ...data };
      setSettings(merged);
      setRevealAfterClose(merged.reveal_after_close);
    } catch {
      setSettings(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (settings?.business_name) {
      document.title = `${settings.business_name} - ${settings.tagline || "Live Results"}`;
    }
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
